import { getLabelColor } from 'helpers/util'

export const setCompetitorsColor = competitors => {
  const colors = {}
  competitors.attributes.overview.forEach((item, index) => {
    colors[item.competitor] = getLabelColor(index)
  })
  return {
    attributes: {
      ...competitors.attributes,
      colors
    }
  }
}
const updateCompetitor = (competitorsList, amendsList) => {
  return amendsList.map(competitor => {
    const amendCompetitor =
      competitorsList.find(item => {
        if (item?.data?.attributes?.competitorUuid && competitor?.attributes?.competitorUuid) {
          return item.data.attributes.competitorUuid === competitor.attributes.competitorUuid
        }
        return false
      }) || {}
    return {
      data: {
        attributes: {
          ...amendCompetitor?.data?.attributes,
          ...competitor?.attributes
        }
      }
    }
  })
}

const updateCompetitors = (keywordsList, amendsList) => {
  return keywordsList.map(keyword => {
    const competitorsArray = amendsList.filter(competitor => competitor.id === keyword.id)
    if (competitorsArray.length) {
      const competitorResults = updateCompetitor(
        keyword?.attributes?.competitorResults || [],
        competitorsArray
      )
      return {
        ...keyword,
        attributes: {
          ...keyword.attributes,
          competitorResults
        }
      }
    }
    return keyword
  })
}

export default updateCompetitors
